import { createFileRoute, Navigate } from '@tanstack/react-router';

import { CaregiverEngagementTemplatesCard } from '@apps/web/components/settings/caregiver_engagement_templates_card';
import {
    SettingsPageSections,
    SettingsPageShell,
    useSettingsGates,
} from '@apps/web/features/settings';

export const Route = createFileRoute('/_app/settings/caregiver-engagement')({
    component: CaregiverEngagementPage,
});

function CaregiverEngagementPage() {
    const { organizationId, gates } = useSettingsGates();
    if (!gates.canManageOrgSettings) {
        return <Navigate to="/settings" replace={true} />;
    }
    if (!gates.caregiverEngagement) {
        return <Navigate to="/settings" replace={true} />;
    }
    if (organizationId === null) {
        return null;
    }

    return (
        <SettingsPageShell
            title="Caregiver engagement"
            description="Recognition, retention, and check-in texts Phoebe can send to caregivers."
        >
            <SettingsPageSections>
                <CaregiverEngagementTemplatesCard
                    organizationId={organizationId}
                    variant="embedded"
                />
            </SettingsPageSections>
        </SettingsPageShell>
    );
}
